module.exports = "query runReport($id:String!,$filters:JsonObject!){runReport(id:$id,filters:$filters){sql data}}"